import { motion } from "framer-motion";
import Container from "../../components/ui/container";
import { Card, CardContent } from "../../components/ui/card";
import { Code, Palette, LineChart, UserCog, Mail, ClipboardList, HeadphonesIcon, Globe } from "lucide-react";
import { Button } from "../../components/ui/button";

const services = [
  {
    icon: Code,
    title: "Development",
    description: "Expert developers for web, mobile, and software development projects"
  },
  {
    icon: Palette,
    title: "Design",
    description: "UI/UX designers and creative professionals for stunning visuals"
  },
  {
    icon: LineChart,
    title: "Digital Marketing",
    description: "SEO specialists, content creators, and social media experts"
  },
  {
    icon: UserCog,
    title: "Virtual Assistance",
    description: "Administrative support and project management professionals"
  },
  {
    icon: Mail,
    title: "Email Management",
    description: "Inbox organization and professional email correspondence"
  },
  {
    icon: ClipboardList,
    title: "Data Entry",
    description: "Accurate and efficient data processing and management"
  },
  {
    icon: HeadphonesIcon,
    title: "Customer Support",
    description: "24/7 customer service and technical support assistance"
  },
  {
    icon: Globe,
    title: "Content Writing",
    description: "Professional content creation and copywriting services"
  }
];

export default function Services() {
  return (
    <section id="services" className="py-20">
      <Container>
        <div className="text-center max-w-2xl mx-auto mb-12">
          <motion.h2 
            className="text-3xl font-bold"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            viewport={{ once: true }}
          >
            Our Services
          </motion.h2>
          <motion.p 
            className="mt-4 text-muted-foreground"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.1 }}
            viewport={{ once: true }}
          >
            Find the perfect talent for your specific business needs
          </motion.p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {services.map((service, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              viewport={{ once: true }}
              className="h-full"
            >
              <Card className="h-full hover:shadow-lg transition-shadow">
                <CardContent className="pt-6 flex flex-col h-full">
                  <div className="bg-primary/10 rounded-full p-3 w-fit mb-4">
                    <service.icon className="h-6 w-6 text-primary" />
                  </div>
                  <h3 className="text-xl font-semibold mb-2">
                    {service.title}
                  </h3>
                  <p className="text-muted-foreground flex-grow">
                    {service.description}
                  </p>
                </CardContent>
              </Card>
            </motion.div>
          ))}
        </div>
         <motion.p 
            className="mt-10 text-muted-foreground text-center "
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.1 }}
            viewport={{ once: true }}
          >
            Also other services but not limited to this.
          </motion.p>
      </Container>
    </section>
  );
}